import { render, staticRenderFns } from "./linshi.vue?vue&type=template&id=35dd46ec&scoped=true&"
import script from "./linshi.vue?vue&type=script&lang=js&"
export * from "./linshi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dd46ec",
  null
  
)

export default component.exports